import React from 'react';
import {Box, IconButton, Typography, Avatar, Button} from '@mui/material';
import SearchComponent from '../components/SearchComponent';
import SearchIcon from "@mui/icons-material/Search";
import LoginIcon from '@mui/icons-material/Login';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface HeroSectionProps {
    isMobile: boolean;
    categories: any[];
    onCategorySelect: (category: string) => void;
    onSearch: (query: string) => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ isMobile, categories, onCategorySelect, onSearch }) => {

    const navigate = useNavigate();
    const { user } = useAuth();

    const handleLoginOrAccount = () => {
        if (user) navigate('/account');
        else navigate('/login');
    };

    return (
        <Box
            className="section"
            sx={{
                width: '100%',
                py: { xs: 2, sm: 3 },
                pb: isMobile ? '220px' : '120px',
            }}
        >
            <Box
                className="card shadow-soft"
                sx={{
                    background: 'linear-gradient(135deg, var(--bg-16) 0%, #fff 100%)',
                    border: '1px solid var(--line)',
                    borderRadius: 3,
                    p: { xs: 2, sm: 3 },
                    position: 'relative',
                }}
            >
                <Typography component="h1" variant={isMobile ? 'h5' : 'h4'} sx={{ fontWeight: 800, mb: 1 }}>
                    Tikrai – kainų palyginimas ir akcijos
                </Typography>
                {/* Login/Profile Button (near search) */}
                {!user && (
                    <Button
                        onClick={handleLoginOrAccount}
                        variant="contained"
                        startIcon={<LoginIcon />}
                        sx={{
                            backgroundColor: '#2e7d32',
                            color: 'white',
                            textTransform: 'none',
                            fontWeight: 700,
                            position: 'absolute',
                            top: { xs: 8, sm: 12 },
                            right: { xs: 8, sm: 12 },
                            px: { xs: 2, sm: 3 },
                            py: { xs: 0.75, sm: 1 },
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                            '&:hover': {
                                backgroundColor: '#1b5e20',
                                boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                                transform: 'translateY(-1px)',
                            },
                        }}
                    >
                        Prisijungti
                    </Button>
                )}
                {user && (
                    <IconButton
                        onClick={handleLoginOrAccount}
                        sx={{
                            padding: { xs: 0.5, sm: 0.75 },
                            color: '#2e7d32',
                            position: 'absolute',
                            top: { xs: 8, sm: 12 },
                            right: { xs: 8, sm: 12 },
                            '&:hover': {
                                backgroundColor: 'rgba(46, 125, 50, 0.08)',
                            },
                        }}
                        aria-label="account"
                        title="Mano paskyra"
                    >
                        {user.photoUrl ? (
                            <Avatar src={user.photoUrl} alt={user.username || 'user'} sx={{ width: { xs: 28, sm: 32 }, height: { xs: 28, sm: 32 } }} />
                        ) : (
                            <AccountCircle sx={{ fontSize: { xs: 28, sm: 32 }, color: '#2e7d32' }} />
                        )}
                    </IconButton>
                )}
                <Typography component="p" variant="subtitle1" sx={{ color: 'text.secondary', mb: 2 }}>
                    Ieškokite, palyginkite ir taupykite
                </Typography>
                <SearchComponent onSearch={onSearch} isMobile={isMobile} categories={categories} onCategorySelect={onCategorySelect} />
            </Box>
        </Box>
    );
};

export default HeroSection;